import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { LogoMark } from "@/components/app/Logo";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const { reload } = useAuth();
  const [state, setState] = useState("checking");

  useEffect(() => {
    const sid = params.get("session_id");
    if (!sid) return setState("error");
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/billing/status/${sid}`);
        if (data.payment_status === "paid") {
          await reload();
          return setState("paid");
        }
      } catch {
        return setState("error");
      }
      tries += 1;
      if (tries >= 15) return setState("timeout");
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [params, reload]);

  return (
    <div className="app-grain flex min-h-screen items-center justify-center p-6" data-testid="payment-success-page">
      <div className="w-full max-w-md rounded-2xl border border-slate-700/60 bg-slate-900 p-8 text-center">
        <LogoMark className="mx-auto h-12 w-12" />
        {state === "checking" && <p className="mt-6 flex items-center justify-center gap-2 text-slate-300" data-testid="payment-checking"><Loader2 className="h-4 w-4 animate-spin" /> Confirmando pagamento…</p>}
        {state === "paid" && (
          <div className="mt-6" data-testid="payment-paid">
            <CheckCircle2 className="mx-auto h-10 w-10 text-emerald-400" />
            <h1 className="mt-3 font-display text-2xl font-bold">Assinatura ativa!</h1>
            <p className="mt-2 text-sm text-slate-400">Obrigado. Seu acesso está liberado.</p>
          </div>
        )}
        {(state === "timeout" || state === "error") && (
          <div className="mt-6" data-testid="payment-not-confirmed">
            <XCircle className="mx-auto h-10 w-10 text-amber-400" />
            <p className="mt-3 text-sm text-slate-300">Ainda não recebemos a confirmação. Se você concluiu o pagamento, aguarde alguns minutos e entre novamente.</p>
          </div>
        )}
        <Button asChild className="mt-8 w-full rounded-full font-semibold" data-testid="payment-go-app-button"><Link to="/">Ir para o app</Link></Button>
      </div>
    </div>
  );
}
